export default __webpack_public_path__ + "static/media/rpl4.c50791c8.jpg";